import script from "./KCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./KCheckbox.vue?vue&type=style&index=0&id=f9888cbe&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9888cbe"]])

export default __exports__